<template>
  <div>
    <section v-if="step == 'zacetek'">
      <v-start-step
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-start-step>
    </section>
    <section v-if="step == 'izberi-posrednika'">
      <v-broker
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-broker>
    </section>
    <section v-if="step == 'naslov-nepremicnine'">
      <v-address
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-address>
    </section>
    <section v-if="step == 'vrsta-nepremicnine'">
      <v-estate-type
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-estate-type>
    </section>
    <section v-if="step == 'tip-nepremicnine'">
      <v-estate-sub-type
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-estate-sub-type>
    </section>
    <section v-if="step == 'cena-nepremicnine'">
      <v-pricing
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-pricing>
    </section>
    <section v-if="step == 'namen-uporabe'">
      <v-usage-type
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-usage-type>
    </section>
    <section v-if="step == 'velikost-nepremicnine'">
      <v-size
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-size>
    </section>
    <section v-if="step == 'lokacija-stanovanja'">
      <v-floor
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-floor>
    </section>
    <section v-if="step == 'status-gradnje'">
      <v-construction-status
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-construction-status>
    </section>
    <section v-if="step == 'oprema-nepremicnine'">
      <v-estate-equipment
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-estate-equipment>
    </section>
    <section v-if="step == 'vseljivost'">
      <v-occupany-date
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-occupany-date>
    </section>
    <section v-if="step == 'status-najema'">
      <v-leased-status
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-leased-status>
    </section>
    <section v-if="step == 'status-obnove'">
      <v-renovation-status
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-renovation-status>
    </section>
    <section v-if="step == 'obnova-nepremicnine'">
      <v-property-renovations
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-property-renovations>
    </section>
    <section v-if="step == 'obnova-stanovanja'">
      <v-apartment-renovations
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-apartment-renovations>
    </section>
    <section v-if="step == 'komunalni-prikljucek'">
      <v-utility-connection
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-utility-connection>
    </section>
    <section v-if="step == 'zazidljivost-parcele'">
      <v-buildability-status
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-buildability-status>
    </section>
    <section v-if="step == 'dodatni-podatki-1'">
      <v-extra-data-1
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-extra-data-1>
    </section>
    <section v-if="step == 'dodatni-podatki-2'">
      <v-extra-data-2
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-extra-data-2>
    </section>
    <section v-if="step == 'parkirna-mesta'">
      <v-parking-spaces
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-parking-spaces>
    </section>
    <section v-if="step == 'dokumentacija-nepremicnine'">
      <v-estate-documentation
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-estate-documentation>
    </section>
    <section v-if="step == 'vir-ogrevanja'">
      <v-heating-source
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-heating-source>
    </section>
    <section v-if="step == 'vrsta-ogrevanja'">
      <v-heating-type
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-heating-type>
    </section>
    <section v-if="step == 'energetska-izkaznica'">
      <v-energy-certificate
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-energy-certificate>
    </section>
    <section v-if="step == 'opis-oglasa'">
      <v-add-info
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-add-info>
    </section>
    <section v-if="step == 'fotografije'">
      <v-add-photos
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-add-photos>
    </section>
    <section v-if="step == 'fotografije-dokumentacije'">
      <v-add-documentation-photos
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-add-documentation-photos>
    </section>
    <section v-if="step == 'osebni-podatki'">
      <v-personal-data
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-personal-data>
    </section>
    <section v-if="step == 'predogled'">
      <v-preview-add
        :old="old"
        :routes="routes"
        :validation-errors="validationErrors"
        :step-data="stepData"
      ></v-preview-add>
    </section>
  </div>
</template>

<script>
import StartStep from './Steps/01StartStep.vue';
import Broker from './Steps/02Broker.vue';
import Address from './Steps/03Address.vue';
import EstateType from './Steps/04EstateType.vue';
import EstateSubType from './Steps/05EstateSubType.vue';
import Pricing from './Steps/06Pricing.vue';
import UsageType from './Steps/07UsageType.vue';
import Size from './Steps/08Size.vue';
import Floor from './Steps/09Floor.vue';
import ConstructionStatus from './Steps/10ConstructionStatus.vue';
import EstateEquipment from './Steps/11EstateEquipment.vue'
import OccupancyDate from './Steps/12OccupancyDate.vue';
import LeasedStatus from './Steps/13LeasedStatus.vue';
import RenovationStatus from './Steps/14RenovationStatus.vue';
import PropertyRenovations from './Steps/15PropertyRenovations.vue';
import ApartmentRenovations from './Steps/16ApartmentRenovations.vue';
import UtilityConnection from './Steps/17UtilityConnection.vue';
import BuildabilityStatus from './Steps/18BuildabilityStatus.vue';
import ExtraData1 from './Steps/19ExtraData1.vue';
import ExtraData2 from './Steps/20ExtraData2.vue';
import ParkingSpaces from './Steps/21ParkingSpaces.vue';
import EstateDocumentation from './Steps/22EstateDocumentation.vue';
import HeatingSource from './Steps/23HeatingSource.vue';
import HeatingType from './Steps/24HeatingType.vue';
import EnergyCertificate from './Steps/25EnergyCertificate.vue';
import AddInfo from './Steps/26AddInfo.vue';
import AddPhotos from './Steps/27AddPhotos.vue';
import DocumentationPictures from './Steps/28DocumentationPictures.vue';
import PreviewAdd from './Steps/29PreviewAdd.vue';
import PersonalData from './Steps/30PersonalData.vue';

export default {
  components: {
    "v-start-step": StartStep,
    "v-broker": Broker,
    "v-address": Address,
    "v-estate-type": EstateType,
    "v-estate-sub-type": EstateSubType,
    "v-pricing": Pricing,
    "v-usage-type": UsageType,
    "v-size": Size,
    "v-floor": Floor,
    "v-construction-status": ConstructionStatus,
    "v-estate-equipment": EstateEquipment,
    "v-occupany-date": OccupancyDate,
    "v-leased-status": LeasedStatus,
    "v-renovation-status": RenovationStatus,
    "v-property-renovations": PropertyRenovations,
    "v-apartment-renovations": ApartmentRenovations,
    "v-utility-connection": UtilityConnection,
    "v-buildability-status": BuildabilityStatus,
    "v-extra-data-1": ExtraData1,
    "v-extra-data-2": ExtraData2,
    "v-parking-spaces": ParkingSpaces,
    "v-estate-documentation": EstateDocumentation,
    "v-heating-source": HeatingSource,
    "v-heating-type": HeatingType,
    "v-energy-certificate": EnergyCertificate,
    "v-add-info": AddInfo,
    "v-add-photos": AddPhotos,
    "v-add-documentation-photos": DocumentationPictures,
    "v-personal-data": PersonalData,
    "v-preview-add": PreviewAdd,
  },
  props: {
    old: {
      type: Object,
      required: false,
      default: {},
    },
    step: {
      type: String,
      required: true,
    },
    routes: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Object,
      required: true,
      default: {},
    },
    stepData: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>
